import { useTranslation, withTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Link as ScrollMove } from "react-scroll";
import { Service_CN, redirectURL } from "../../../utils/CommonFunc";
import { useSetRecoilState } from "recoil";
import { MY_INFO_URL, SIGN_IN_URL } from "../../../utils/config/Config";
import { useRecoilValue } from "recoil";
import React, { useState } from "react";
import VWallet from "../vWallet/VWallet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faSignInAlt,
  faUser,
  faThLarge
} from "@fortawesome/free-solid-svg-icons";
import {
  connectSiteState,
  isLoginStateSelector
} from "../../../recoil/userInfoAtom";
import { sideMenuToggleState } from "../../../recoil/commonUiAtom";
import { useLoginCheck } from "hooks/useLoginCheck";

function FixedFooter() {
  const { t } = useTranslation();
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const { service_code } = useParams();
  const setOpenSideMenu = useSetRecoilState(sideMenuToggleState);
  const onClickSideMenu = () => {
    setOpenSideMenu((openSideMenu) => !openSideMenu);
  };
  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const connectSite = useRecoilValue(connectSiteState);
  const isNotLogin = useLoginCheck();

  const walletClick = () => {
    if (!isLoginState.isLogIn) {
      isNotLogin();
      return;
    }

    setIsWalletOpen((prev) => !prev);
  };

  const onClickMyinfo = () => {
    if (isLoginState.isLauncher) {
      window.app.vfunRequestLogin();
    } else {
      redirectURL(
        SIGN_IN_URL(service_code || "vfun"),
        "_self",
        isLoginState.isLauncher
      );
    }
  };
  return (
    <footer id="vfun-fixed-footer">
      <div className="row-w clearfix">
        {connectSite === "vfun" && (
          <ul className="menu">
            <li>
              <Link
                to="#"
                onClick={() =>
                  redirectURL(
                    `${process.env.REACT_APP_PLATFORM_DNS}`,
                    "_self",
                    isLoginState.isLauncher
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faHome as IconProp}
                  className="FontAwesomeIconSpan"
                />
                <br />
                {t("home")}
              </Link>
            </li>
            <li>
              <Link to="#" onClick={onClickSideMenu}>
                <FontAwesomeIcon
                  icon={faThLarge as IconProp}
                  className="FontAwesomeIconSpan"
                />
                <br />
                {t("menu")}
              </Link>
            </li>

            {isLoginState.isLogIn ? (
              <li>
                <Link to="#" onClick={MY_INFO_URL}>
                  <FontAwesomeIcon
                    icon={faUser as IconProp}
                    className="FontAwesomeIconSpan"
                  />
                  <br />
                  {t("my_info")}
                </Link>
              </li>
            ) : (
              <li>
                <Link to="#" onClick={onClickMyinfo}>
                  <FontAwesomeIcon
                    icon={faSignInAlt as IconProp}
                    className="FontAwesomeIconSpan"
                  />
                  <br />
                  {t("signin")}
                </Link>
              </li>
            )}

            {Service_CN ? null : (
              <li>
                <Link to="#" id="fWallet" onClick={walletClick}>
                  <span className="fwallet-click" />
                  <br />
                  {t("v_wallet")}
                </Link>
                <VWallet isWalletOpen={isWalletOpen} idName="fVwallet" />
              </li>
            )}
          </ul>
        )}

        {/* 페이지 스크롤 */}
        <ul className="go-to">
          <li>
            <ScrollMove smooth={true} to="content" title="위로">
              <FontAwesomeIcon
                icon={faAngleDoubleUp as IconProp}
                className="FontAwesomeIconSpan"
              />
            </ScrollMove>
          </li>
          <li>
            <ScrollMove
              smooth={true}
              to={connectSite === "vfun" ? "valofe-footer" : "valofeKoFooter"}
              title="아래로"
            >
              <FontAwesomeIcon
                icon={faAngleDoubleDown as IconProp}
                className="FontAwesomeIconSpan"
              />
            </ScrollMove>
          </li>
        </ul>
      </div>
    </footer>
  );
}
const FixedFooterMemo = React.memo(FixedFooter);
export default withTranslation()(FixedFooterMemo);
